"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notification = void 0;
exports.notification = {
    path: "M15 13.125V8.95833C15 6.4 13.6417 4.25833 11.25 3.69167V3.125C11.25 2.43333 10.6917 1.875 10 1.875C9.30834 1.875 8.75001 2.43333 8.75001 3.125V3.69167C6.36668 4.25833 5.00001 6.39167 5.00001 8.95833V13.125L3.33334 14.7917V15.625H16.6667V14.7917L15 13.125ZM10 18.125C10.9167 18.125 11.6667 17.375 11.6667 16.4583H8.33334C8.33334 17.375 9.08334 18.125 10 18.125ZM6.66668 13.9583H13.3333V8.95833C13.3333 6.89167 12.075 5.20833 10 5.20833C7.92501 5.20833 6.66668 6.89167 6.66668 8.95833V13.9583Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2",
};
